import { RouteLocationNormalized } from 'vue-router';

export const sanitizeRedirectTarget = (redirect: unknown, fallback = '/'): string => {
  if (typeof redirect !== 'string') {
    return fallback;
  }

  const normalizedRedirect = redirect.trim();

  if (normalizedRedirect.length === 0) {
    return fallback;
  }

  if (!normalizedRedirect.startsWith('/')) {
    return fallback;
  }

  if (normalizedRedirect.startsWith('//') || normalizedRedirect.startsWith('/\\')) {
    return fallback;
  }

  return normalizedRedirect;
};

export const useRouteUtilities = (route: RouteLocationNormalized) => {
  const getRedirectTarget = (): string => {
    return sanitizeRedirectTarget(route.query.redirect);
  };

  const hasRedirect = (): boolean => {
    return sanitizeRedirectTarget(route.query.redirect) !== '/';
  };

  return { getRedirectTarget, hasRedirect };
};
